import React from 'react';
import { FormGroup, InputGroup, Label, Input, FormText } from 'reactstrap';
import { CSSTransition } from 'react-transition-group';
import GetNewCodeInput from '../GetNewCodeInput';
import { FMessage } from '../../../hoc/IntlComponents';
import SVG from 'react-inlinesvg';
import { STATIC_PATH } from '../../../config';
import PaymentExistingBankCardRU from './PaymentExistingBankCardRU';

export default ({
  data: {
    type,
    theme,
    wallets,
    multiple,
    isSlave,
    title,
    placeholder,
    newWalletSMSInputTargetId,
    newWalletSMSInput, newWalletSMSInputError,
    shouldHideNewWallet,
    openWalletMenuId,
  },
  renderWalletsLabel,
  getFormClassName,
  inputFocusHandler,
  inputBlurHandler,
  handleDelete,
  toggleWalletMenu,
  handleEditWallet,
  renderMutedText,
  focusNewInput,
  handleNewWalletChange,
  handleSubmit,
  renderNewPurseField,
  // handleEdit,
}) => {
  return (
    <>
      {wallets.map(({ id, number, type, firstname, lastname }, index) =>
        // type === 3 ? (
        //   <PaymentExistingBankCardRU
        //     key={id}
        //     data={{
        //       id,
        //       number,
        //       index,
        //       type,
        //       isSlave,
        //       inputFocusHandler,
        //       inputBlurHandler,
        //       theme,
        //       renderWalletsLabel,
        //       newWalletSMSInputTargetId,
        //       focusNewInput,
        //       newWalletSMSInput,
        //       handleNewWalletChange,
        //       placeholder,
        //       newWalletSMSInputError,
        //       title,
        //       multiple,
        //       handleDelete,
        //       firstname,
        //       lastname,
        //       handleEdit,
        //     }}
        //   />
        // ) : (
          <div key={id} className='payment-purses-list'>
            <FormGroup className={`form-group-upper-label ${getFormClassName(index)}`}> 
              {renderWalletsLabel({ id, index })}

              <InputGroup>
                <Input
                  id={`purse-${type}-${id}`}
                  // className="text-uppercase"
                  value={number}
                  onChange={() => false}
                  readOnly={number && number.length && !isSlave}
                  disabled={isSlave}
                  onFocus={inputFocusHandler}
                  onBlur={inputBlurHandler}
                />

                {multiple && (
                  <div className="wallet-actions">
                    <button
                      className="wallet-actions-trigger"
                      type="button"
                      aria-label="Действия с кошельком"
                      aria-expanded={openWalletMenuId === id}
                      onClick={() => toggleWalletMenu(id)}
                    >
                      <span aria-hidden="true">{openWalletMenuId === id ? '×' : '⋮'}</span>
                    </button>

                    {openWalletMenuId === id && (
                      <div className="wallet-actions-menu">
                        <button type="button" onClick={() => handleEditWallet(id, number)}>
                          <SVG
                            src={`${STATIC_PATH}/img/action-icons/edit_icon.svg`}
                            width="20"
                            height="20"
                            cacheRequests
                          />
                          <FMessage id="main.edit" />
                        </button>
                        <button
                          className="wallet-actions-delete"
                          type="button"
                          disabled={isSlave}
                          onClick={() => handleDelete(id, type)}
                        >
                          <SVG
                            src={`${STATIC_PATH}/img/action-icons/bin-icon-2.svg`}
                            width="20"
                            height="20"
                            cacheRequests
                          />
                          <FMessage id="main.delete" />
                        </button>
                      </div>
                    )}
                  </div>
                )}
              </InputGroup>
              {type === 41 && 0 === index && (
                <FormText color="orange">
                  <FMessage id={'payment-data.wallets.code-gen.new.41dop'} />
                </FormText>
              )}
              {/* <FormText color="muted">
                {renderMutedText({
                  index,
                  keyForSMSInput: `purse-${type}-${id}_${index}`,
                  id,
                  type,
                })}
              </FormText> */}
            </FormGroup>
            {/* <CSSTransition
              in={newWalletSMSInputTargetId === `purse-${type}-${id}_${index}`}
              timeout={0}
              classNames="new-wallet"
              onEnter={focusNewInput}
            >
              <GetNewCodeInput
                title={title}
                type={type}
                value={newWalletSMSInput}
                handleChange={handleNewWalletChange}
                handleSubmit={() => handleSubmit('newWalletSMSInputError', id)}
                placeholder={placeholder}
                error={newWalletSMSInputError}
                id={`purse-${type}-${id}-sms`}
                className="new-wallet"
                onFocus={inputFocusHandler}
                onBlur={inputBlurHandler}
              />
            </CSSTransition> */}
          </div>
        // )
      )}

      {multiple &&
        !shouldHideNewWallet &&
        renderNewPurseField({ index: wallets.length, noWallets: !wallets.length })}
    </>
  );
};
